// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-base__header {
  z-index: 2;
  position: absolute;
  top: -4px;
  right: 3px;
  display: flex;
  flex-direction: row;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/components/ChartKitBase/components/Header/Header.scss"],"names":[],"mappings":"AACI;EACI,UAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAAR","sourcesContent":[".chartkit-base__header {\n  z-index: 2;\n  position: absolute;\n  top: -4px;\n  right: 3px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
